import React from "react";

export default function PlatformModeSwitch() {
  return null;
}
